import React, { useState } from 'react';
import { useGenerationTask } from '../hooks/use-generation-task.js';
import { useProjectModel } from '../../../model.js';
import { generateDataCollection } from './generate.js';
import { ChooseCollectionStep } from './steps.js';
import {
  CompleteGeneration,
  CompleteGenerationMessage,
} from '../CompleteGeneration.js';

export const useGenerateDataCollection = () => {
  const { model } = useProjectModel();
  const [collectionName, setCollectionName] = useState<string>();

  const generationTask = useGenerationTask(async () => {
    if (collectionName) {
      return generateDataCollection(model.projectFolder, collectionName);
    }
  }, [model.projectFolder, collectionName]);

  return [
    <ChooseCollectionStep
      onSubmit={setCollectionName}
      collectionName={collectionName}
    />,
    <CompleteGeneration
      generationTask={generationTask}
      extensionType={'data collection'}
      successMessage={CompleteGenerationMessage.SuccessMessage({
        learnMoreUrl:
          'https://dev.wix.com/docs/api-reference/business-solutions/cms/collection-management/data-collections-extension/data-collections-extension-object',
      })}
      route={collectionName}
    />,
  ];
};
